import { render, staticRenderFns } from "./scopingDeck.vue?vue&type=template&id=28b95cf4&"
import script from "./scopingDeck.vue?vue&type=script&lang=js&"
export * from "./scopingDeck.vue?vue&type=script&lang=js&"
import style0 from "./scopingDeck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports